import axios from 'axios'
import { EventTypes } from 'redux-segment'

export function fetchSites(companyParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITES_FETCH',
      payload: axios(`/companies/${companyParam}/sites`)
    })
    .then((response) => {
      dispatch({
        type: 'SEGMENT_TRACK_ACTION',
        meta: {
          analytics: [{
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Load Company Sites',
              properties: {
                siteCount: response.action.payload.data.length
              }
            }
          }]
        }
      })
    })
  }
}

export function fetchChildCompanySites(companyParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHILD_COMPANY_SITES_FETCH',
      payload: axios(`/companies/${companyParam}/child_company_sites`)
    })
    .then((response) => {
      dispatch({
        type: 'SEGMENT_TRACK_ACTION',
        meta: {
          analytics: [{
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Load Child Company Sites',
              properties: {
                siteCount: response.action.payload.data.length
              }
            }
          }]
        }
      })
    })
  }
}

export function getSite(companyParam,siteParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITE_FETCH',
      payload: axios(`/companies/${companyParam}/sites/${siteParam}`)
    })
  }
}

export function updateSite(companyParam,siteParam,updateParams) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITE_UPDATE',
      payload: axios.put(`/companies/${companyParam}/sites/${siteParam}`,updateParams)
    })
  }
}

export function duplicateParentCompanySite(companyParam,siteParam,params) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PARENT_COMPANY_SITE_DUPLICATE',
      payload: axios.post(`/companies/${companyParam}/sites/${siteParam}/child_company_site_duplicate`,params)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/SiteActions.js